// Ring the numbered dot of one note on the current page (spec §3 click-through).
// agentation keeps its notes per page in localStorage `feedback-annotations-<pathname>` and draws each dot
// as [data-annotation-marker] with its number (position + 1) inside. A note written on another device is
// not in that list: return false and the panel shows the note text only.
export const RING_CLASS = 'pn-ring';
const RING_MS = 6000;
const STYLE_ID = 'pn-ring-style';
let timer: ReturnType<typeof setTimeout> | null = null;

function ensureStyle(doc: Document) {
  if (doc.getElementById(STYLE_ID)) return;
  const s = doc.createElement('style');
  s.id = STYLE_ID;
  s.textContent = `.${RING_CLASS}{box-shadow:0 0 0 4px rgba(200,105,28,.55),0 0 0 8px rgba(200,105,28,.2)!important;z-index:2147483000!important}`;
  doc.head.appendChild(s);
}

export function focusNote(clientId: string, opts: { pathname?: string; doc?: Document } = {}): boolean {
  const doc = opts.doc ?? document;
  const pathname = opts.pathname ?? window.location.pathname;
  let list: unknown;
  try { list = JSON.parse(localStorage.getItem(`feedback-annotations-${pathname}`) ?? '[]'); } catch { return false; }
  if (!Array.isArray(list)) return false;
  const idx = list.findIndex((a: any) => a && a.id === clientId);
  if (idx < 0) return false;
  const markers = [...doc.querySelectorAll<HTMLElement>('[data-annotation-marker]')];
  const target = markers.find(m => m.textContent?.trim() === String(idx + 1)) ?? markers[idx];
  if (!target) return false;
  ensureStyle(doc);
  for (const m of doc.querySelectorAll(`.${RING_CLASS}`)) m.classList.remove(RING_CLASS);
  if (timer) clearTimeout(timer);
  target.classList.add(RING_CLASS);
  timer = setTimeout(() => { target.classList.remove(RING_CLASS); timer = null; }, RING_MS);
  return true;
}
